import React, { VFC, memo, useEffect, useState } from 'react';
import { Center } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';

export const ReloadURL: VFC = memo(() => {
  const navigate = useNavigate ();
  const search = useLocation().search;
  const [ execFlag, setExecFlag ] = useState(false);
  
  useEffect(() => {
    setExecFlag(true);
  }, []);
  
  useEffect(() => {
    if( execFlag === false ) return;
    
    setExecFlag(false);
    const query = new URLSearchParams(search);
    console.log(query.get('url'));
    navigate(query.get('url') ?? '/home');
  }, [execFlag,navigate,search]);

  return <Center>しばらくお待ちください・・・</Center>;
});
